export default __webpack_public_path__ + "static/assets/59bbfa4c671b55fef0a39404d6cb3249.png";